import React from 'react';
import { Divider } from 'semantic-ui-react'

const RtesGesTro1 = ({autorizacUA, styles, handleClickRegr, handleClickSel1, handleClickSel2}) => {
  const a152001 = autorizacUA.findIndex( autorizac => autorizac === "152001" );
  const a152005 = autorizacUA.findIndex( autorizac => autorizac === "152005" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      
      <Divider inverted />

      {a152001!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large dollar sign violet icon"></i>
        Gestión recaudo
      </button>
      }
      {a152005!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large dollar sign violet icon"></i>
        Edad de mora
      </button>
      }
    </div>
  )
};

export default RtesGesTro1
